import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { ResponseEventParams } from '@webapp/survey/src/entities/response-machine';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { MatrixApi } from './common/matrix';

export class MatrixTextAnswerApi extends MatrixApi {
    public change({ responseActor, id: questionId }: QuestionContext, evt: ResponseEventParams): void {
        const { value } = evt;
        responseActor.send({ type: 'CHANGE', value, questionId });
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { groupsActors, id, responseActor, answersActors } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        const answerIds = excludeHiddenAnswers(answersActors).map((a) => a.getSnapshot().context.id.toString());
        return {
            question: id,
            data: groupsActors.flatMap((groupActor) => {
                const { id: groupId, responses } = groupActor.getSnapshot().context;
                return Object.entries(responses)
                    .filter(([answerId]) => answerIds.includes(answerId.toString()))
                    .map(([answerId, r]) => {
                        if (r?.getSnapshot().context?.value === CANTRATE_ID) {
                            return {
                                group: groupId,
                                answer: parseInt(answerId),
                                bool: true,
                                cantRate: true,
                            };
                        }

                        return {
                            group: groupId,
                            answer: parseInt(answerId),
                            bool: true,
                            text: String(r?.getSnapshot().context?.value),
                        };
                    });
            }),
            comment,
        };
    }

    public validate(data: QuestionContext): boolean {
        const {
            answersActors,
            params: { required },
            groupsActors,
        } = data;

        if (required) {
            const allAnswersValidationList = [];

            excludeHiddenAnswers(answersActors).forEach((answerActor) => {
                const answer = answerActor.getSnapshot().context;
                const isAnswerValid = groupsActors.every((groupActor) => {
                    const group = groupActor.getSnapshot().context;
                    const responseValues = [...Object.entries(group.responses)].map(([answerId, r]) => ({
                        ...r.getSnapshot().context,
                        answerId,
                    }));

                    const findAnswerInGroup = responseValues.find(
                        (response) => response.answerId === answer.id.toString(),
                    );

                    return findAnswerInGroup ? Boolean(findAnswerInGroup.value) : false;
                });

                answerActor.send({ type: 'SET_VALID', value: isAnswerValid });
                allAnswersValidationList.push(isAnswerValid);
            });

            return allAnswersValidationList.every((item) => item);
        }

        return true;
    }
}
